import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'changepassword.title',
    defaultMessage: 'Choose a new password',
  },
  button: {
    id: 'changepassword.button',
    defaultMessage: 'Continue',
  },
  passwordPlaceholder: {
    id: 'changepassword.password.placeholder',
    defaultMessage: 'Enter new password',
  },
  passwordLabel: {
    id: 'changepassword.password.label',
    defaultMessage: 'Password',
  },
  errorMessage: {
    id: 'changepassword.error.message',
    defaultMessage:
      'Something went wrong while attempting to change your password. Please try again.',
  },
  emptyPasswordErrorMessage: {
    id: 'changepassword.error.password.empty.message',
    defaultMessage: 'Please enter a password',
  },
  securityResetTitle: {
    id: 'changepassword.security.reset.title',
    defaultMessage: 'Reset your password',
  },
});
